export const MAINTENANCE_LAYOUTS = {
  SIMPLE: 'SIMPLE',
  WITH_FUNCTION_NAME: 'WITH_FUNCTION_NAME',
} as const;

export type MaintenanceLayouts = (typeof MAINTENANCE_LAYOUTS)[keyof typeof MAINTENANCE_LAYOUTS];
